import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import formMixin from '../shared/vue/mixins/form';
import dataLayerPush from '../shared/utils/analytics';

export default function manageService() {
  const el = select('[data-vue-app="manage-service"]');
  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      mixins: [formMixin],
      data: {
        vlgSession: '',
        selectedAccount: '',
      },
      mounted() {
        this.vlgSession = (this.$el.dataset) ? this.$el.dataset.vlgSession : '';
        this.selectedAccount = (this.$el.dataset) ? this.$el.dataset.selectedAccount : '';
      },
      /**
       * Methods
       */
      methods: {
        redirectToSEW(e) {
          if (e) {
            e.preventDefault();
          }
          const ssaItem = e.srcElement.closest(".ssa-item");
          const linkUrl = ssaItem.dataset["linkUrl"];
          this.$refs.srmForm.action = linkUrl;
          if (linkUrl) {
            this.$refs.vlgSession.value = this.vlgSession;
            this.$refs.selectedAccount.value = this.selectedAccount;
            switch (e.currentTarget.id) {
              case "moveService":
                dataLayerPush('MoveService');
                break;
              case "stopService":
                dataLayerPush('StopService');
                break;
              case "startService":
                dataLayerPush('StartService');
                break;
              default:
            }
            this.$refs.srmForm.submit();
          }
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/manageService.js